import { render, staticRenderFns } from "./MyBOT.vue?vue&type=template&id=4aa91d84&scoped=true"
import script from "./MyBOT.vue?vue&type=script&lang=js"
export * from "./MyBOT.vue?vue&type=script&lang=js"
import style0 from "./MyBOT.vue?vue&type=style&index=0&id=4aa91d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa91d84",
  null
  
)

export default component.exports